module.exports = {
	createYearSlider: function(chart, yearData, series, seriesData, yearSliderLabel, updateData, startPosition) {
		var yearSliderContainer = chart.createChild(window.am4core.Container);
		yearSliderContainer.layout = 'vertical';
		yearSliderContainer.width = window.am4core.percent(100);
		yearSliderContainer.parent = chart.bottomAxesContainer;
		yearSliderContainer.padding(16, 0, 16, 0);

		var yearSlider = yearSliderContainer.createChild(window.am4core.Slider);
		yearSlider.orientation = 'horizontal';
		yearSlider.start = startPosition;
		yearSlider.exportable = false;
		yearSlider.background.fill = window.am4core.color('#939393');
		yearSlider.background.fillOpacity = 1;
		yearSlider.minHeight = 6;

		var yearLabel = chart.createChild(window.am4core.Label);
		yearLabel.align = 'center';
		yearLabel.fontSize = 26;
		yearLabel.text = yearSliderLabel + String(yearData.End);
		yearLabel.x = window.am4core.percent(50);
		yearLabel.y = -40;
		yearLabel.isMeasured = false;
		yearLabel.horizontalCenter = 'middle';

		var startGrip = yearSlider.startGrip;
		startGrip.showSystemTooltip = false;
		startGrip.background.fill = window.am4core.color('#0071B9');

		yearSlider.events.on('rangechanged',
			function () {
				updateData(chart, yearData.Start + Math.round(yearSlider.start * (yearData.End - yearData.Start)),
					yearLabel, series, seriesData, yearSliderLabel);
			});

		return yearSlider;
	}
};
